enum RequestType {
  LEAVE = 'Leave',
  PASSPORT = 'Passport',
  SALARY = 'Salary',
  RESUMPTION = 'Resumption',
  OVERSEAS = 'Overseas',
  IT_REQUISITION = 'ITRequisition',
  MATERIAL = 'Material',
  ATTENDANCE = 'Attendance',
  ATTENDANCE_PROFILE = 'AttendanceProfile',
  RESIGNATION = 'Resignation',
  PURCHASE = 'Purchase',
  TENDER = 'Tender',
  ESS_TASK_REQUEST = 'ESSTaskRequest',
  MR_TASK_REQUEST = 'MRTaskRequest',
}

export default RequestType;
